import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategorySection() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-3">
            探索精彩内容
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            八大内容类目，总有你感兴趣的。点击分类，发现更多精彩视频
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group bg-background-50 border border-background-200/70 rounded-2xl p-5 md:p-6 hover:border-primary-300 transition-all duration-300 hover:-translate-y-1"
            >
              <div className={`w-12 h-12 md:w-14 md:h-14 rounded-xl bg-gradient-to-br ${cat.color} flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300`}>
                <i className={`${cat.icon} text-white text-xl md:text-2xl`}></i>
              </div>
              <h3 className="font-heading text-foreground-900 text-base md:text-lg mb-1.5">{cat.name}</h3>
              <p className="text-foreground-500 text-xs md:text-sm leading-relaxed line-clamp-2">{cat.description}</p>
              <div className="mt-3 flex items-center gap-1 text-xs text-foreground-400">
                <span>{cat.count.toLocaleString()} 个视频</span>
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform duration-200"></i>
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}